import { toast } from "react-toastify";

import { ERROR_MESSAGE } from "../../constants/error_message";

const CustomErrorMessage = ({ messageKey, extraText }) => {
  switch (messageKey) {
    case ERROR_MESSAGE.WRONG_CREDENTIAL:
      return <span className="text-danger">ຊື່ ຫຼື ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ</span>;
    case ERROR_MESSAGE.MEMBER_NOT_FOUND:
      return <span className="text-danger">ຊື່ ຫຼື ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ</span>;
    case ERROR_MESSAGE.REQUIRED_USERNAME:
      return <span className="text-danger">ກະລຸນາປ້ອນຊື່ຜູ້ໃຊ້</span>;
    case ERROR_MESSAGE.REQUIRED_PASSWORD:
      return <span className="text-danger">ກະລຸນາປ້ອນລະຫັດຜ່ານ</span>;
    case ERROR_MESSAGE.REQUIRED_PASSWORD_CONFIRM:
      return <span className="text-danger">ກະລຸນາຢືນຢັນລະຫັດຜ່ານ</span>;
    case ERROR_MESSAGE.PASSWORD_NOT_MATCH:
      return <span className="text-danger">ລະຫັດຜ່ານບໍ່ຕົງກັນ</span>;
    case ERROR_MESSAGE.REQUIRED_AMOUNT:
      return <span className="text-danger">ກາລູນາປ້ອນຈຳນວນເງິນ</span>;
    case ERROR_MESSAGE.INSUFFICIENT:
      return <span className="text-danger">ຈຳນວນເງິນບໍ່ພຽງພໍ</span>;
    case ERROR_MESSAGE.ACCOUNT_NOT_ACONNECTED:
      return <span className="text-danger">ລູກຄ້າຍັງບໍຜູກບັນຊີ</span>;
    case ERROR_MESSAGE.REQUIRED_CODE:
      return <span className="text-danger">ກະລຸນາປ້ອນ Code</span>;
    case ERROR_MESSAGE.INVALID_CODE:
      return <span className="text-danger">Code ບໍ່ຖືກຕ້ອງ</span>;
    default:
      return <span className="text-danger">ມີບາງຢ່າງຜິດພາດ {extraText}</span>;
  }
};

const CustomSuccessMessage = () => {
  return <span className="text-success">ສຳເລັດ</span>;
};

export const showErrorToast = (messageKey, extraText) => {
  toast.error(
    <CustomErrorMessage messageKey={messageKey} extraText={extraText} />
  );
};

export const showSuccessToast = (messageKey) => {
  toast.success(<CustomSuccessMessage messageKey={messageKey} />);
};

export default CustomErrorMessage;
